import escapeRegExp from 'lodash.escaperegexp';
import getCheckNumber from './getCheckNumber';
import getCheckString from './getCheckString';
/**
 * @internal
 */
export function convertKeywordToCriterion(keyword, options = {
    pathAlias: {},
}) {
    const { caseSensitive, pathAlias } = options;
    const regexpFlags = caseSensitive ? '' : 'i';
    let negate = false;
    if (keyword.startsWith('-')) {
        negate = true;
        keyword = keyword.substring(1);
    }
    const colon = keyword.indexOf(':');
    if (colon > -1) {
        const value = keyword.substring(colon + 1);
        if (colon > 0) {
            const key = keyword.substring(0, colon);
            if (key === 'is') {
                // a property path exists
                return {
                    type: 'exists',
                    negate,
                    key: new RegExp(`(^|\\.)${escapeRegExp(value)}(\\.|$)`, regexpFlags),
                };
            }
            else {
                return {
                    type: 'matches',
                    negate,
                    key: pathAlias[key]
                        ? pathAlias[key]
                        : new RegExp(`(^|\\.)${escapeRegExp(key)}(\\.|$)`, regexpFlags),
                    checkNumber: getCheckNumber(value),
                    checkString: getCheckString(value, regexpFlags),
                };
            }
        }
    }
    return {
        type: 'matches',
        negate,
        checkNumber: getCheckNumber(keyword),
        checkString: getCheckString(keyword, regexpFlags),
    };
}
export function convertKeywordsToCriteria(keywords, options = {
    pathAlias: {},
}) {
    return keywords.map((keyword) => {
        return convertKeywordToCriterion(keyword, options);
    });
}
//# sourceMappingURL=convertKeywordToCriterion.js.map